import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { userApi } from '../../../api/users';

export const useMyProfile = () => {
  return useQuery({
    queryKey: ['myProfile'],
    queryFn: () => userApi.getMyProfile(),
  });
};

export const useUpdateMyProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { fullNameDhivehi?: string | null }) => userApi.updateMyProfile(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['myProfile'] });
      notifications.show({
        title: 'Success',
        message: 'Profile updated successfully',
        color: 'green',
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: 'Error',
        message: error?.response?.data?.error || 'Failed to update profile',
        color: 'red',
      });
    },
  });
};

export const useUploadMySignature = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (file: File) => userApi.uploadMySignature(file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['myProfile'] });
      queryClient.invalidateQueries({ queryKey: ['mySignature'] });
      notifications.show({
        title: 'Success',
        message: 'Signature uploaded successfully',
        color: 'green',
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: 'Error',
        message: error?.response?.data?.error || 'Failed to upload signature',
        color: 'red',
      });
    },
  });
};

export const useMySignature = () => {
  return useQuery({
    queryKey: ['mySignature'],
    queryFn: () => userApi.getMySignature(),
    retry: false,
  });
};
